(function () {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const designMode = document.documentElement.classList.contains('shopify-design-mode');
  const main = document.querySelector('main[data-template]');

  if (!main || designMode) return;

  const template = String(main.dataset.template || '').toLowerCase();
  if (template.includes('product')) return;

  const markReveal = (el, delayMs) => {
    if (!el || el.hasAttribute('data-v1-reveal')) return;
    el.setAttribute('data-v1-reveal', '');
    el.style.setProperty('--v1-reveal-delay', `${delayMs}ms`);
  };

  const collectRevealNodes = (scope = document) => {
    const sections = Array.from(scope.querySelectorAll('main > .shopify-section, .shopify-section'));

    sections.forEach((section, sectionIndex) => {
      const root = section.querySelector(
        '.hero, .section, .p4-why-works, .p4-consult-hero-section, .p4-consult-conversation-section, .p4-consult-path-section, .p4-consult-outcomes-section, [class*="ai-help-guide-"], [class*="ai-collection-browser-"]'
      );
      if (!root) return;

      markReveal(root, Math.min(sectionIndex * 20, 140));

      const spotlightGroups = Array.from(
        root.querySelectorAll(
          '.hero__content-wrapper, .group-block-content, .section-content-wrapper, .collection-card, .resource-card, .blog-post-card, .p4-why-works__header, .p4-why-works__cards, [class*="ai-help-guide-container-"], [class*="ai-collection-browser__menu-"], [class*="ai-collection-browser__content-"]'
        )
      );

      spotlightGroups.forEach((node, nodeIndex) => {
        if (nodeIndex > 5) return;
        markReveal(node, Math.min(60 + nodeIndex * 35, 220));
      });

      const detailTargets = Array.from(
        root.querySelectorAll(
          '.text-block, .button-block, .image-block, .group-block, .collection-card, .resource-card, .blog-post-card, [class*="ai-expert-card-"], [class*="ai-google-maps-container-"], .p4-why-works__card, .p4-why-works__header > *, [class*="ai-help-guide-heading-"], [class*="ai-help-guide-description-"], [class*="ai-help-guide-button-"], [class*="ai-help-guide-icon-wrapper-"], [class*="ai-collection-browser__menu-button-"], [class*="ai-collection-browser__product-card-"], .p4-consult-hero__copy > *, .p4-consult-frame, .p4-consult-note, .p4-consult-card, .p4-consult-step, .p4-consult-outcomes__footer > *'
        )
      );

      detailTargets.forEach((node, nodeIndex) => {
        if (node.closest('[data-v1-reveal]') === node) return;
        if (nodeIndex > 14) return;
        markReveal(node, Math.min(90 + nodeIndex * 28, 360));
      });
    });
  };

  collectRevealNodes();

  const revealNodes = Array.from(document.querySelectorAll('[data-v1-reveal]'));
  if (revealNodes.length === 0) return;

  if (reduceMotion) {
    revealNodes.forEach((node) => node.classList.add('is-revealed'));
    return;
  }

  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-revealed');
        obs.unobserve(entry.target);
      });
    },
    {
      root: null,
      rootMargin: '0px 0px -10% 0px',
      threshold: 0.08,
    }
  );

  revealNodes.forEach((node) => observer.observe(node));

  // If any node misses observation due to late layout/async content, reveal it anyway.
  window.setTimeout(() => {
    document.querySelectorAll('[data-v1-reveal]:not(.is-revealed)').forEach((node) => {
      node.classList.add('is-revealed');
    });
  }, 1400);

  document.addEventListener('shopify:section:load', (event) => {
    collectRevealNodes(event.target || document);
    document.querySelectorAll('[data-v1-reveal]:not(.is-revealed)').forEach((node) => observer.observe(node));
  });
})();
